<template>
  <div style="width: 100%;">
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <DataTable
      :value="sales"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rowHover="true"
      :selection.sync="selectedSales"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Actual Sales"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="defaultSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows" 
    >
      <template #empty> No sales found. </template>
      <template #loading> Loading sales data. Please wait. </template>
      <Column 
        header="Actions"
        :frozen="true"
      >
      </Column>
      <Column selectionMode="multiple" headerStyle="width: 2.4rem;"></Column>
      <Column 
        v-for="(col, index) of colSelectedFieldsForTable" 
        :key="col.dbField + '_' + index"
        :field="getOptionLabel(col)[0]" 
        :sortField="sortKeyOf(col, colSelectedFieldsForTable)"
        :header="col.fieldName" 
        :sortable="true"
        :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'"
      >
        <template #body="slotProps">
          <div
            style="height: 40px; padding: 10px 0px;"
            @click="openOP(slotProps.data, col, $event)"
            :class="getStyle1(slotProps.data, col)"
          >
            {{ getToShow(slotProps.data, col) }}
          </div>
        </template>
      </Column>
      <!-- <Column
        field="sYear"
        header="Year"
        headerStyle="width: 3rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.sYear }}
          </div>
        </template>
      </Column>
      <Column
        field="sMonth"
        header="Month"
        headerStyle="width: 5rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.sMonth }}
          </div>
        </template>
      </Column>
      <Column
        field="branch"
        header="Branch"
        headerStyle="width: 4rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.branch ? slotProps.data.branch.branchCode : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="custCode"
        header="Cust Code"
        headerStyle="width: 5rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.custCode }}
          </div>
        </template>
      </Column>
      <Column
        field="salesValue"
        header="Forecast Value"
        headerStyle="width: 5rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ formatString(slotProps.data.forecastValue) }}
          </div>
        </template>
      </Column>
      <Column
        field="dateAdded"
        header="Date Added"
        headerStyle="width: 6rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.dateAdded }}
          </div>
        </template>
      </Column>
      <Column
        field="addedBy"
        header="Added By"
        headerStyle="width: 10rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.addedBy ? slotProps.data.addedBy.fullName : '' }}
          </div>
        </template>
      </Column> -->
      <Column
        field="errMsg"
        header="Error Message"
        headerStyle="width: 25rem"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.errMsg }}
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import { columnSortKey, sortChangeFor } from '@/mbp/universalComponents/listSort'
import { formatAmount, formatCurrency } from '@/utils/money'
import HistoryTable from '../customer/customerHistoryTable'

export default {
  components: {
    HistoryTable
  },
  props: [
    "sales",
    "requesting",
    "filters",
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    "colSelectedFields",
    'colSelectedFieldsForTable'
  ],
  data: () => ({
    selectedSales: null,
    sale: {},
    customersTableKey1: 0,
    
    previousPage: null,
    tableKey1: 0,
    columnsKey1: 0,
    defaultSortField: '',
    defaultSortOrder: 0,
    defaultFirstPage: 0,
    defaultRows: 25,
    sendingRequest: false,
    
    customerHistory: [],
    customerHistoryLoading: false,
    tempCustomer: {},
  }),
  computed: {
    customersTableKey: {
      set(val) {
        this.customersTableKey1++
      },
      get() {
        return 'customersTableKey' + this.customersTableKey1.toString()
      }
    },
    loading() {
      if (this.sales && this.sales[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    selectedSales(val) {
      this.$emit('selected-records', val);
    },
    sales(val) {
      
      this.customersTableKey++
    }
  },
  methods: {
    onSort(event) {
      // C2: one sort, for the column clicked (by its own key, then its id), not every column sharing the last db_field segment
      const change = sortChangeFor(event, this.colSelectedFieldsForTable)
      if (change) this.$emit('sortChange', change)
    },
    sortKeyOf(col, cols) {
      return columnSortKey(col, cols)
    },
    onPage(event) {
      // 
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatString(value) {
      if (value) {
        const amount = formatAmount(value)
        return amount !== null ? amount : String(value)
      } else {
        return '0'
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    openOP(data, col, event) {
      
      
      if (data && data.customer && data.customer.customerId && event.target && event.target.className === "under_lined") {
        this.tempCustomer = data.customer
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customer.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    getStyle1(data, col) {
      if (
        col.dbField === 'quote.quoteVer' ||
        col.dbField === 'customer.custName'
      ) {
        return 'under_lined'
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 

      let b = ''
      if (a.length > 1) {
        b = data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else {
        return b
      }
    }
  }
}
</script>

<style>

</style>